// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOperationsFilePdfOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 20a1 1 0 0 0 1-1v-9h-5a1 1 0 0 1-1-1V4H7a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1zm.672-12L14 4.328V8zm-4-6a2 2 0 0 1 1.414.586l4.328 4.328A2 2 0 0 1 20 8.328V19a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3zM7 15.814v-4.05h1.67c.473 0 .752.092 1.016.344.258.247.392.575.392 1 0 .402-.113.746-.328.982-.225.258-.558.376-1.042.376h-.655v1.348zm1.977-2.696c0-.338-.188-.51-.575-.51h-.35v1.015h.345c.402 0 .58-.156.58-.505zm3.145-1.354c1.069 0 1.993.935 1.993 2.025 0 1.09-.924 2.025-1.993 2.025H10.57v-4.05zm.602 2.82c.188-.21.29-.494.29-.795 0-.3-.102-.585-.29-.79-.21-.236-.468-.343-.86-.343h-.242v2.267h.242c.392 0 .65-.102.86-.339zM17 12.656h-1.268v.677h1.15v.891h-1.15v1.59H14.68v-4.05H17z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgOperationsFilePdfOutline;
